import { render, staticRenderFns } from "./ApproveAuctionGrantAction.vue?vue&type=template&id=3deb1f81&scoped=true&"
import script from "./ApproveAuctionGrantAction.vue?vue&type=script&lang=ts&"
export * from "./ApproveAuctionGrantAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb1f81",
  null
  
)

export default component.exports